import { useCallback, useRef } from 'react'

import { useMsal } from '@azure/msal-react'
import { useHistory } from 'react-router-dom'

import {
  TEMP_LOG_FUNCTION,
  formatTokenResponseData,
  msTokenGenerate,
} from '../api/auth'
import { loginRequest } from '../msAuthConfig'

import { useHandleDbTokenResponse } from './useHandleDbTokenResponse'

export const useAcquireMsalToken = () => {
  const { instance } = useMsal()
  const activeAccount = instance.getActiveAccount()
  const msalTokenAquisitionAttempted = useRef<boolean>(false)
  const handleTokenResponse = useHandleDbTokenResponse()

  const history = useHistory()

  const generateTokenFromMsToken = useCallback(
    async (token: string, redirectOnFailure?: boolean) => {
      try {
        const tokenResponse = await msTokenGenerate(token)
        handleTokenResponse(formatTokenResponseData(tokenResponse))
      } catch (e) {
        if (redirectOnFailure) {
          history.push('/login', { errorMessage: 'Unable to authenticate' })
        }
      }
    },
    [handleTokenResponse, history],
  )

  return useCallback(
    async (redirectOnFailure?: boolean) => {
      if (instance) {
        await instance.initialize()

        if (activeAccount && !msalTokenAquisitionAttempted.current) {
          msalTokenAquisitionAttempted.current = true
          instance
            .acquireTokenSilent(loginRequest)
            .then(response => {
              msalTokenAquisitionAttempted.current = true
              if (response && response.accessToken) {
                // eslint-disable-next-line no-console -- TODO: Remove debug console.log
                console.log('Acquire token silent success', response)
                TEMP_LOG_FUNCTION(
                  `Acquire token silent success: ${JSON.stringify(response)}`,
                )
                generateTokenFromMsToken(
                  response.accessToken,
                  redirectOnFailure,
                )
              } else {
                msalTokenAquisitionAttempted.current = false
              }
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper error type
            .catch((e: any) => {
              // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
              console.error('Acquire token silent failed', e)
              TEMP_LOG_FUNCTION(
                `Aquire token silent failed: ${JSON.stringify(e)}`,
              )
              msalTokenAquisitionAttempted.current = false
            })
        }
      } else {
        // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
        console.error('Msal instance not found')
        TEMP_LOG_FUNCTION('Msal instance not found')
        throw new Error('Msal instance not found')
      }
    },
    [generateTokenFromMsToken, instance, activeAccount],
  )
}
